import React, { useState, useEffect } from 'react';
import { ArrowRight, Zap } from 'lucide-react';

interface IntroMotionProps {
  onComplete: () => void;
}

export const IntroMotion: React.FC<IntroMotionProps> = ({ onComplete }) => {
  const [stage, setStage] = useState<'enter' | 'visible' | 'exit'>('enter');

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setStage('visible');
    }, 300);

    const timer2 = setTimeout(() => {
      setStage('exit');
    }, 2500);

    const timer3 = setTimeout(() => {
      onComplete();
    }, 3100);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#040C16] text-white transition-opacity duration-700 ${
        stage === 'exit' ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Background ambient lighting */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#040C16] via-[#07111E] to-[#040C16] opacity-95" />

      {/* Decorative Solar Emblem */}
      <div className="relative z-10 flex flex-col items-center max-w-xl px-6 text-center">
        <div className="mb-6 p-3 rounded-3xl bg-white shadow-2xl shadow-sky-500/30 w-24 h-24 sm:w-28 sm:h-28 flex items-center justify-center overflow-hidden animate-bounce">
          <img src="/plus_sd_logo.png" alt="플러스에스디" className="w-full h-full object-contain" />
        </div>

        {/* Sub title badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-slate-900 border border-sky-500/40 text-sky-400 text-xs tracking-widest font-extrabold uppercase mb-5 shadow-sm">
          <Zap className="w-3.5 h-3.5 text-sky-400" />
          <span>PLUS SD SOLAR & ROOF SOLUTION</span>
        </div>

        {/* Main Branding Quote */}
        <div className="space-y-3 my-2">
          <h2 className="text-xl sm:text-2xl text-slate-300 font-extrabold tracking-tight">
            +SD <span className="text-amber-400 font-black">플러스에스디</span>
          </h2>
          <p className="text-2xl sm:text-3xl font-black text-white leading-relaxed tracking-tight">
            "내 돈 0원으로 <span className="text-amber-400">지붕수리 해결</span>하고, <br className="hidden sm:inline" />
            <span className="text-amber-400">평생 연금 임대료</span>를 받으세요!"
          </p>
        </div>

        <button
          onClick={onComplete}
          className="mt-8 px-6 py-2.5 rounded-full bg-slate-900 hover:bg-slate-800 border border-slate-700 text-slate-200 font-extrabold text-xs transition-all flex items-center gap-2 cursor-pointer"
        >
          <span>빠르게 둘러보기</span>
          <ArrowRight className="w-3.5 h-3.5 text-amber-400" />
        </button>
      </div>
    </div>
  );
};
